import { Component, OnInit } from '@angular/core';
import { SearchParams } from '../../../search/models/search-params.model';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchStatus } from '../../../search/models/search-status.model';
import { SearchCriteria, Condition, Clause } from '../../../search/models/search-filter-model';
import { ButtonItem } from '../../../button/button.model';
import { SearchEvent } from '../../../search/models/search-event';
import { Observable } from 'rxjs/Observable';
import { ResourceService, AlertService } from 'sce-core';
import { SearchService } from '../../../search/search.service';
import { HttpHeaders } from '@angular/common/http';
import { SearchableEntityDataEditorService } from '../../../services/searchable-entity/searchable-entity-data-editor.service';
import { NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT } from '../../../search/search-constants';
import { PropertyChangeEvent } from '../../../models/property-change-event';
import { PageDefinition } from '../../../search/models/page-definition.model';

@Component({
  selector: 'lfwms-assign-driver-popup',
  templateUrl: './assign-driver-popup.component.html',
  styleUrls: ['./assign-driver-popup.component.css']
})
export class AssignDriverPopupComponent {

  public assignDriverSearchService: SearchService;
  public showTable: boolean = true;
  public tableMode = 'V'; // Should be bound from template and changed as per button action
  public buttonPanelButtonArray = [
    new ButtonItem('Edit', this.coreServiceRegistry.resourceService.get('btn_edit'), 'assgn_driv_edit', 'icon_edit.svg', []),
    new ButtonItem('Delete With Privilege', this.coreServiceRegistry.resourceService.get('btn_delete'), 'assgn_driv_del', 'icon_delete.svg', []),
    new ButtonItem('Add Row', this.coreServiceRegistry.resourceService.get('lbl_AddNewRow'), 'assgn_driv_add', 'icon_edit.svg', []),
    new ButtonItem('Save', this.coreServiceRegistry.resourceService.get('btn_save'), '', 'icon_save.svg', []),
  ];



  private http$ = this.coreServiceRegistry.http$;
  private resourceService = this.coreServiceRegistry.resourceService;

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService
  ) { }

  public initializeComponents(primaryKeyName: string, primaryKeyValue: string) {
    // initialize button sbased on table mode
    this.refreshButtons();
    // initialize the table and search context */
    // const testValue = primaryKeyName === 'loadKey' ? '0000071086' : '0000058989';
    this.initializeAssignDriverSearchContext(primaryKeyName, primaryKeyValue);
  }

  public initializeAssignDriverSearchContext(keyColName: string, columnValue: string) {

    const tabledId = keyColName === 'loadKey' ? 'assignloaddritd' : 'assignmboldritd';

    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = tabledId;
    searchParams.isFullFetch = true;
    // searchParams.columnCount = 15; ///???
    // searchParams.idProperty = '';
    /* Data editor
     ** DataTableEditorService -- is needed  for tableheader filter to work. use in readonly tables.
     Filter might misbehave if datatype is not set properly in metdata from db.
     ** SearchableEntityDataEditorService --  reqd for table editing - propvaluechanged method etc..*/
    searchParams.tableEditor = new SearchableEntityDataEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    //  searchParams.alertService = this.alertService;
    // Client side pagination disabled
    searchParams.paginateLocally = false;
    // searchParams.defaultPageSize = 100;
    // LFWM-3191-fix to load buttons by privilege in popups.
    searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonPanelButtonArray);

    const tableConfig: DataTableConfig = new DataTableConfig();
    // tableConfig.defaultCellRenderer = ReshipCellRendererComponent;
    // tableConfig.supportFiltering = false; // ??
    tableConfig.editable = true; // To allow table edits.ELse always in view mode
    //  tableConfig.isColumnEditable = this.isColumnEditable ; // method can be overridden if needed
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;  // hide filter input boxes in header
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.assignDriverSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

    this.assignDriverSearchService.fetchMetadata()
      .subscribe(data => this._getAssignDriverTableData(keyColName, columnValue));

  }

  private _getAssignDriverTableData(keyColName: string, columnValue: string) {

    this.assignDriverSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */

    const searchCriteria = new SearchCriteria();
    const searchCondition = new Condition();
    searchCondition.isMandatory = true;
    const defaultClause = new Clause();
    defaultClause.operation = '=';
    defaultClause.column = keyColName;
    defaultClause.value = columnValue;
    searchCondition.clauses = [defaultClause];
    searchCriteria.conditions.push(searchCondition);

    this.assignDriverSearchService.setSearchCriteria(searchCriteria);

    this.assignDriverSearchService.performSearch();


    // Subscription for the Search Events from Search Service.
    const eventSubscription = this.assignDriverSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_ROW_EVENT) {
          this.handleAddNewLineItem(event,keyColName, columnValue);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.assignDriverSearchService.setNewPageEventInProgress(true);
          this.save();
        }
      });

    /*  Override the  propertyValueChanged func of DataTableEditor to catch all the valuechange calls
    so that we can modify dependent fields based on the driver dropdwon change.
    Dependent values are present id dropdown userDefined property.
    DriverCode dropdown values mapping --
     udf01: "REDEST" --> Short --> JobCode
      udf02: null --> Long --> Desc 
    };
    */
    const propertyValueChangedFunc = function (event: PropertyChangeEvent): boolean {
      if (event.property === 'driver') {
        const matchedDriverInfo = this.searchServiceVariable.metadata.columnList
          .filter(item => item.elementId === 'driver')[0].values
          .filter(driverInfo => driverInfo.key.trim() !== '' && (driverInfo.key.trim() === event.value.trim()));
        if (matchedDriverInfo.length > 0) {
          event.row.cells['jobCode'].cVal = matchedDriverInfo[0].userDefineValues.udf01;
          event.row.cells['jobDescr'].cVal = matchedDriverInfo[0].userDefineValues.udf02;
          event.row.cells['driverName'].cVal = matchedDriverInfo[0].value;
          // not needed since auto refreshed  this.searchServiceVariable.getPagedData.aggridApi.refreshCells({ force: true });
        } else {
          // if no matches reset.Applicable for key === '',  --select- also
          event.row.cells['jobCode'].cVal = '';
          event.row.cells['jobDescr'].cVal = '';
          event.row.cells['driverName'].cVal = '';
        }
      }
      return true;
    };
    // Asiign the func and the serachservice fior use inside the function as the scope will be inside TableEditor
    this.assignDriverSearchService.searchParams.tableEditor['propertyValueChanged'] = propertyValueChangedFunc;
    this.assignDriverSearchService.searchParams.tableEditor['searchServiceVariable'] = this.assignDriverSearchService;

  }

  /** Start:: Button Related */
  private refreshButtons() {
    this.buttonPanelButtonArray.forEach((button: ButtonItem) => {
      switch (button.action) {
        case 'Edit': {
          button.isEnabled = (this.tableMode === 'V');
          button.isVisible = (this.tableMode === 'V');
          break;
        }
        // LFWM-3191- made a new api /withPriv (replacement for setup api)
        //  to pass the privileges for checking the privileges at the backend level.
        case 'Save': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
        case 'Add Row': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
        // LFWM-3191- made a new api /withPriv (replacement for setup api)
        //  to pass the privileges for checking the privileges at the backend level.
        case 'Delete With Privilege': {
          button.isEnabled = true;
          button.isVisible = true;
          break;
        }
      }
    });
  }

  public handleButtonAction(action: string) {

    if (action === 'Edit') {
      this.tableMode = 'E';
      this.refreshButtons();
    } else if (action === 'Save') {
      this.save();
    } else if (action === 'Delete With Privilege') {
      this.deleteLineItem();
    }
  }

  /** end:: Button Related */



  /**
  * this method has the auto generation of line number logic & prepopulating loadKey
  * @param event
  */
  public handleAddNewLineItem(event,keyColName, columnValue) {

    this.getMaxValueForIdProperty().subscribe((response: any) => {
      if (response && response.propertyValues && response.propertyValues.length > 0) {
        const maxLineNo = response.propertyValues[0].cVal;

        const pagedData = this.assignDriverSearchService.getPagedData();

        let lineNo = maxLineNo ? maxLineNo : '00001';
        pagedData.pageRows.forEach(row => {
          const rowLineNo = Number.parseInt(row.cells['lineNo'].cVal);
          if (Number.parseInt(lineNo) <= rowLineNo) {
            lineNo = (rowLineNo + 1) + '';
          }
        });

        // if the current table spans across multiple pages adjust the max value
        const pageDefinition: PageDefinition = this.assignDriverSearchService.getPagedData().pageDefinition;
        if ((pageDefinition.recordCount > pageDefinition.pageSize) && pagedData.pageRows.length === 1 ) {
          lineNo = (Number.parseInt(lineNo) + 1) + '';
        }

        let prependZeroes = 5 - lineNo.length; // ie 00001 - 5places
        let prependString = '';
        while (prependZeroes > 0) {
          prependZeroes--;
          prependString = prependString + '0';
        }

        lineNo = prependString + lineNo;

        // Autopopulate lineNo and loadkey/MbolKey for new rows
        event.selectedRow.cells['lineNo'].cVal = lineNo;
        event.selectedRow.cells[keyColName].cVal = columnValue;
        // keyColName can be either loadKey OR mbolKey
        // get the changes reflected in aggrid UI instantly by refreshing gridApi
        pagedData.aggridApi.refreshCells({ force: true });
        // this.assignDriverSearchService.searchParams.tableEditor.refreshCells();
      }
    });

  }


  /**
    * Method to get the maximum value for a column in the table
    */
  public getMaxValueForIdProperty() {
    const response$ = this.http$.post(`api/data/` + this.assignDriverSearchService.searchParams.tableId + `/function`,
      {
        'functionType': 'MAX',
        'propertyNames': ['lineNo'],
        'filterCriteria': this.assignDriverSearchService.getSearchCriteria()
      })
      .catch((error: any) => {
        return Observable.throw('Could not fetch the max value');
      });
    return response$;
  }

  /*
  Add Update LineItems 
  */
  public save() {
    const pagedRows = this.assignDriverSearchService.getEditedRows();
    const allRows = this.assignDriverSearchService.getAllRows();
    let savePopupPrivilege = '';
    if (allRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (pagedRows.length === 0) {
      this.alertService.clearAll().warn(this.resourceService.get('msg_no_mod'));
      this.coreServiceRegistry.navigationService.preventNavigation = false;
      this.tableMode = 'V';
      this.refreshButtons();
      return;
    }
    const finalSaveData: Array<any> = [];
    let hasValidationError: boolean = false;

    pagedRows.forEach((row: any) => {
      const rowData = [];
      const rowDataArray: any = row['cells'];
      // Validate for no driverId
      if (rowDataArray['driver'] && (rowDataArray['driver'].cVal.trim() === '')) {
        this.alertService.clearAll().error(this.resourceService.get('msg_drvr_code_mndatry'));
        hasValidationError = true;
        return; // returns only from forEach
      }
      if (row['isNewRow']) {
        Object.keys(rowDataArray).forEach((element: any) => {
          if (rowDataArray[element] && (element !== 'isNewItem')) {
            const newElements: any = {
              'cName': element,
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newElements);
          } else {
            const newRowFlag: any = {
              'cName': 'isNewItem',
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newRowFlag);
          }
        });
        savePopupPrivilege = 'assgn_driv_add';
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.assignDriverSearchService.searchParams.tableId,
          'detailItems': [],
          'privilege': savePopupPrivilege
        });
      } else {
        Object.keys(rowDataArray).forEach((element: any) => {

          const oldValue: any = {
            'cName': 'original_' + rowDataArray[element].cName,
            'cVal': rowDataArray[element].cValOrig
          };
          const newValue: any = {
            'cName': rowDataArray[element].cName,
            'cVal': rowDataArray[element].cVal
          };
          rowData.push(oldValue);
          rowData.push(newValue);
        });
        savePopupPrivilege = 'assgn_driv_edit';
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.assignDriverSearchService.searchParams.tableId,
          'detailItems': [],
          'privilege': savePopupPrivilege
        });
      }
    });
    if (!hasValidationError) {

      this.saveDataBackendCall(finalSaveData)
        .subscribe((resp: any) => {
          if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
            if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
              // code to reload the  detail grid
              this.alertService.clearAll();
              this.alertService.success(this.resourceService.get('msg_save_succ'));
              this.coreServiceRegistry.navigationService.preventNavigation = false;
              this.tableMode = 'V';
              this.refreshButtons();
              this.assignDriverSearchService.performSearch();
            } else {
              this.alertService.clearAll();
              this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
            }
          } else {
            if (resp.error) {
              this.alertService.clearAll();
              this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
            }
          }
        }, (error) => {
          this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
        });

    }
  }

// LFWM-3191- made a new api /withPriv (replacement for setup api)
  public saveDataBackendCall(request) {
    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request))
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

  /* Call to delete selected lineItem
  */
 // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteLineItem() {
    const sucessMessage: string = 'msg_del_succ';
    const confDialogMsg: string = 'msg_itm_conf_del_assgn_driv';
    let privilege = 'assgn_driv_del';
    const noOfLineItems = this.assignDriverSearchService.getPagedData().pageDefinition.recordCount;
    const selectedRows = this.assignDriverSearchService.getSelectedRows();
    if (noOfLineItems === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (selectedRows.length > 0) {

      const confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
      confirmDialogService.confirmDialog(this.resourceService.get(confDialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const selectedRow = this.assignDriverSearchService.getSelectedRows();
            const finalDeleteData: Array<any> = [];

            selectedRow.forEach((row: any) => {
              const rowData = [];
              let rowDataArray: Array<any> = [];
              rowDataArray = row['cells'];
              Object.keys(rowDataArray).forEach((element: any) => {
                const item: any = {
                  'cName': rowDataArray[element].cName,
                  'cVal': rowDataArray[element].cVal
                };
                rowData.push(item);
              });

              finalDeleteData.push({
                'moduleProperties': rowData,
                'screenType': this.assignDriverSearchService.searchParams.tableId,
                'privilege': privilege
              });
            });
            if (finalDeleteData.length > 0) {
              this.deleteSelectedLineItemBackendCall(finalDeleteData)
                .subscribe((resp: any) => {
                  if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
                    if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                      // code to reload the  detail grid
                      this.alertService.clearAll();
                      this.alertService.success(this.resourceService.get(sucessMessage));
                      this.assignDriverSearchService.performSearch();
                    } else {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  } else {
                    if (resp.error) {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  }
                }, (error) => {
                  this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
                });
            }
          }
        });
    } else {
      this.alertService.clearAll();
      this.alertService.error(this.resourceService.get('msg_no_detail'));
    }
  }
// LFWM-3191- made a new api /withPriv (replacement for setup api)
  public deleteSelectedLineItemBackendCall(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }





}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component.ts